import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isMinErrorOrMultiError: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CENQtyMultiCheckoutErr: HandlerType = props => {
    props.dispatch({
        type: "Pages/CenQtyMultiCheckoutErrState",
        isMinErrorOrMultiError: props.parameter.isMinErrorOrMultiError,
    });
};

export const chain = [CENQtyMultiCheckoutErr];

const cenQtyMultiCheckoutErr = createHandlerChainRunner(chain, "CENQtyMultiCheckoutErr");
export default cenQtyMultiCheckoutErr;
